export const IconStarFavorite: {
  name: 'icon_star_favorite-537a83262a62'
} = {
  name: 'icon_star_favorite-537a83262a62'
}
